const moduleErrors = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
];

export const isCausedByMissingModule = (errorMessage?: string) =>
  moduleErrors.some((error) => errorMessage?.toLowerCase().includes(error));
